import { styled } from '../../../theme/styled';
import { TabsTokens } from '../model';

export const TabIndicator = styled('span', {
  name: 'Tabs',
  slot: 'Indicator',
})(({ theme }) => {
  return {
    position: 'absolute',
    bottom: -1,
    left: 0,
    backgroundColor: TabsTokens.TextColor(theme.palette['brand gray']),
    width: '100%',
    height: 2,
    borderRadius: 1,
  };
});
